// @flow weak

import React, {
  PureComponent
}                     from 'react';
import PropTypes      from 'prop-types';
import Collapse       from 'react-collapse';
import MenuHeader     from './menuHeader/MenuHeader';
import MenuLinks      from './menuLinks/MenuLinks';
import {aclUtil} from "../../../../views/util"
// activeView:       PropTypes.string.isRequired,
class Menu extends PureComponent {
  static propTypes = {
    headerTitle:      PropTypes.string.isRequired,
    headerBackColor:  PropTypes.string,
    activeView:       PropTypes.string,
    parentMenuKey:  PropTypes.string,
    
    views: PropTypes.arrayOf(
      PropTypes.shape({
        name:       PropTypes.string.isRequired,
        linkTo:     PropTypes.string.isRequired,
        faIconName: PropTypes.string.isRequired,
        itemCount:  PropTypes.number
      })
    ).isRequired,
    initialCollapseState: PropTypes.bool
  };

  static defaultProps = {
    headerBackColor: '#172D44'
  };

  state = {
    isCollapsed: true
  };

  componentDidMount() {
    const { initialCollapseState } = this.props;
    if (typeof initialCollapseState === 'boolean') {
      this.setInitialCollapse(initialCollapseState);
    }
  }

  render() {
    const {
      headerTitle,
      headerBackColor,
      activeView,
      views,
      parentMenuKey
    } = this.props;
    const { isCollapsed } = this.state;
    return (
     
      <li>
       
        {(views && views.length==1)? 
       
        <MenuLinks
          activeView={activeView}
          views={views}
          backColor={headerBackColor}
        />
        :
        ((aclUtil.isPrimaryMenuAccessible(parentMenuKey, 'parent')) ?
        <div className="admin">
          <MenuHeader
          title={headerTitle}
          isCollapsed={!isCollapsed}
          onClick={this.handlesCollapseClick}
          backColor={headerBackColor}
          
        />
          <Collapse
          isOpened={!isCollapsed}>
          <MenuLinks
            activeView={activeView}
            views={views}
            backColor={headerBackColor}
          />
        </Collapse>
        </div>
        : '')
        }
    </li>
    );
  }

  setInitialCollapse = (value) => {
    this.setState({ isCollapsed: value });
  }

  handlesCollapseClick = (evt) => {
    evt.preventDefault();
    const { isCollapsed } = this.state;
    this.setState({ isCollapsed: !isCollapsed });
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/menu/Menu.js